import React, { useEffect, useState } from 'react'
import WebComponentContainer from '../generic/WebComponentContainer'
import useEventBus from '../generic/useEventBus'

export default ({ vehicleName, trim, vin, currentStep, pages, stepClick, mileage, theme }) => {
  const [pageLoaded, setPageLoaded] = useState(false)
  const [showLoader, setShowLoader] = useState(true)

  useEffect(() => {
    setPageLoaded(true)
  }, [])
  useEffect(() => {
    setShowLoader(false)
  }, [])
  ////// **** - Integrated Breadcrumb Code - **** //////
  useEventBus('NavigateToPage', event => {
    stepClick(pages[event.index], event.index)
  })

  return (
    <WebComponentContainer pageLoadingComplete={pageLoaded} withLoader={showLoader} maxWidth="100%" location={'breadcrumb'} theme={theme}>
      <ico-breadcrumb vin={vin} vehicle-y-m-m={vehicleName} trim={trim} is-branded={true} current-page={currentStep} mileage={mileage} theme={theme} />
    </WebComponentContainer>
  )
}
